import ne66 from './images/ne66.png'
import debangkuaidi from './images/debangkuaidi.png'
import ems from './images/ems.png'
import guotongkuaidi from './images/guotongkuaidi.png'
import huitongkuaidi from './images/huitongkuaidi.png'
import jd from './images/jd.png'
import kuayue from './images/kuayue.png'
import pjbest from './images/pjbest.png'
import shentong from './images/shentong.png'
import shunfeng from './images/shunfeng.png'
import suer from './images/suer.png'
import xinfengwuliu from './images/xinfengwuliu.png'
import youshuwuliu from './images/youshuwuliu.png'
import youzhengguonei from './images/youzhengguonei.png'
import yuantong from './images/yuantong.png'
import yuantongguoji from './images/yuantongguoji.png'
import yunda from './images/yunda.png'
import zhaijisong from './images/zhaijisong.png'
import zhongtong from './images/zhongtong.png'
import ewe from './images/ewe.png'
import quanyikuaidi from './images/ewe.png'
import jtexpress from "./images/jitu.png"


export interface IExpressCompany {
    id: string
    name: string
    img: string
}

export const expressCompanyList: Array<IExpressCompany> = [
    {
        id: 'shunfeng',
        name: '顺丰快递',
        img: shunfeng,
    },
    {
        id: 'yuantong',
        name: '圆通速递',
        img: yuantong,
    },
    {
        id: 'shentong',
        name: '申通快递',
        img: shentong,
    },
    {
        id: 'zhongtong',
        name: '中通快递',
        img: zhongtong,
    },
    {
        id: 'yunda',
        name: '韵达快递',
        img: yunda,
    },
    {
        id: 'huitongkuaidi',
        name: '百世快递',
        img: huitongkuaidi,
    },
    {
        id: 'jd',
        name: '京东物流',
        img: jd,
    },
    {
        id: 'pjbest',
        name: '品骏快递',
        img: pjbest,
    },
    {
        id: 'guotongkuaidi',
        name: '国通快递',
        img: guotongkuaidi,
    },
    {
        id: 'debangkuaidi',
        name: '德邦快递',
        img: debangkuaidi,
    },
    {
        id: 'suer',
        name: '速尔快递',
        img: suer,
    },
    {
        id: 'xinfengwuliu',
        name: '信丰物流',
        img: xinfengwuliu,
    },
    {
        id: 'youshuwuliu',
        name: '优速物流',
        img: youshuwuliu,
    },

    {
        id: 'youzhengguonei',
        name: '邮政快递包裹',
        img: youzhengguonei,
    },
    {
        id: 'ems',
        name: 'EMS',
        img: ems,
    },
    {
        id: 'yuantongguoji',
        name: '圆通国际',
        img: yuantongguoji,
    },
    {
        id: 'kuayue',
        name: '跨越速运',
        img: kuayue,
    },
    {
        id: 'zhaijisong',
        name: '宅急送',
        img: zhaijisong,
    },
    {
        id: 'ne66',
        name: '安能快递',
        img: ne66,
    },
    {
        id: 'ewe',
        name: 'EWE全球快递',
        img: ewe,
    },
    {
        id: 'quanyikuaidi',
        name: '全一快递',
        img: quanyikuaidi,
    },
    {
        id: 'jtexpress',
        name: '极兔速递',
        img: jtexpress,
    },
]
